var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5556 13.8149C17.4536 13.8149 16.3716 13.6425 15.3462 13.3037C14.8437 13.1323 14.226 13.2895 13.9194 13.6045L11.8955 15.1323C9.54831 13.8794 8.1025 12.4341 6.86669 10.1045L8.34958 8.13334C8.73484 7.74859 8.87303 7.18656 8.70747 6.65922C8.36716 5.62844 8.19428 4.5469 8.19428 3.4444C8.19433 2.64795 7.54638 2 6.74997 2H3.44436C2.64795 2 2 2.64795 2 3.44436C2 12.5732 9.42676 19.9999 18.5556 19.9999C19.352 19.9999 20 19.352 20 18.5556V15.2592C20 14.4629 19.352 13.8149 18.5556 13.8149Z",
    fill: "#62656D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.2f59edc5411d3892cb31875b5f338839.svg";
export { ForwardRef as ReactComponent };